import { render, staticRenderFns } from "./IconDownload.vue?vue&type=template&id=212f31c2"
import script from "./IconDownload.vue?vue&type=script&lang=js"
export * from "./IconDownload.vue?vue&type=script&lang=js"
import style0 from "./IconDownload.vue?vue&type=style&index=0&id=212f31c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports